import React, { useEffect } from 'react';
import { Image, View, Text } from 'react-native';
import { getChemistAppLogo } from '../../utils/services/chemist/ChemistStoreUtils';
import { getImagePath, isChemistStoreLoaded } from '../../utils/services/CommonUtils';
import { executePendingNavigation } from '../../utils/services/webapp-services/OnAppLoadInitializer';

import AppTheme from '../../AppTheme';
import TextStyle from '../../TextStyle';
import AppStyles from '../../AppStyles';

const SplashScreen = ({ navigation }: { navigation: any }, props: any) => {

  const isStandAlonApp = window.matchMedia('(display-mode: standalone)').matches

  const chemistStoreLoaded = isChemistStoreLoaded()
  const pharmacyDeeplinkData = JSON.parse(localStorage.getItem('profileDeeplinkData'))
  const chemistStoreName = pharmacyDeeplinkData?.['pharmacyName'] ?? ''

  useEffect(() => {
    console.log('#w/h', { width: AppTheme.appWidth, height: AppTheme.appHeight })
    setTimeout(() => {
      console.log("props?.route?.params", props?.route?.params,)
      executePendingNavigation(navigation, props?.route?.params?.refreshAppData)
    }, isStandAlonApp ? 0 : 1000)
  })

  return (
    <View >{isStandAlonApp ? null : chemistStoreLoaded && chemistStoreName ?
      getChemistAppLogo() ? <View style={[AppStyles.alignCenter,
      { width: window.innerWidth, height: document.documentElement.clientHeight }]}>
        <Image style={{ height: 192, width: 192 }}
          source={{ uri: getChemistAppLogo() }} />
      </View> : <View style={[AppStyles.alignCenter,
      { width: AppTheme.appWidth, height: document.documentElement.clientHeight }]}>
        <View>
          <Text style={[TextStyle.text20, {
            textAlign: "center"
          }]}>Welcome To</Text>
          <Text style={[TextStyle.text24b, {
            marginTop: 4, width: AppTheme.appWidth * 0.75,
            textAlign: "center", flexWrap: "wrap"
          }]}>{chemistStoreName}</Text>
        </View>
        <View style={[AppStyles.bottomFix, AppStyles.alignCenter, { bottom: 40 }]}>
          <Text style={[TextStyle.text12xb]}>Powered by:</Text>
          <Image style={{ height: 40, width: 113, marginTop: 16 }}
            source={{ uri: getImagePath('/images/aayuChemistLogo.png') }} />
        </View>
      </View> : <View style={{
        justifyContent: "center", alignItems: "center",
        width: AppTheme.appWidth, height: document.documentElement.clientHeight
      }}><Image source={{
        uri: getImagePath(
          '/images/icons/medcords_aayu_vertical.svg'),
        height: 174, width: 200
      }} /></View>
    }</View>
  )
}

export default SplashScreen;
